export default __webpack_public_path__ + "static/media/highq.01a9efd7.svg";